export const POSTHOG_PUBLIC_KEY =
  process.env.NODE_ENV === "production" ? "phc_nSqWkBd0u4WCXDITt7WJ9p4GVtqpktncwOvLM49uM3x" : "";

export const POSTHOG_OPTIONS = {
  api_host: "https://app.posthog.com",
};
